<template>
  <div class="parent-profile">
    <sipaee-profile-add-student
      v-if="isStudentAddSectionVisible"
      ref="sipaeeStudentAdd"
      v-model="user"
      @student-selected="setStudentAddressIfExist"
      :readonly="readonly"
    />

    <sipaee-location
      v-if="isLocationFormVisible"
      ref="sipaeeLocation"
      v-model="user"
      :readonly="readonly"
    />

    <sipaee-profile-contract
      v-model="user.sipaeeInfo"
      :user="user"
      @remove="removeContract"
      @update-contract="updateContract"
      class="mt-4"
    />
  </div>
</template>

<script>
import {
  removeContract,
  getContracts,
  updateContract,
} from '@/modules/users/api';

import SipaeeProfileContract from './SipaeeProfileContract.vue';
import SipaeeProfileAddStudent from './SipaeeProfileAddStudent.vue';
import SipaeeLocation from './SipaeeLocation.vue';

import alertMixin from '@/mixins/alert.mixin';
import Roles from '@/utils/constants/rolesIds';

export default {
  name: 'ParentProfile',
  components: {
    SipaeeProfileContract,
    SipaeeProfileAddStudent,
    SipaeeLocation,
  },
  mixins: [alertMixin],
  model: {
    prop: 'user',
    event: 'user-changed',
  },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    model: {},
  }),
  computed: {
    isLocationFormVisible() {
      return this.user.roles.some((item) =>
        [
          Roles.Conciliador,
          Roles.JuezAdministrativo,
          Roles.Investigador,
          Roles.EspecialistaInvestigaciónEE,
        ].includes(item.roleId.toUpperCase())
      );
    },
    isStudentAddSectionVisible() {
      return this.user.roles.some((item) =>
        [Roles.PadreEncargado].includes(item.roleId.toUpperCase())
      );
    },
  },
  async mounted() {},
  methods: {
    async removeContract(contract, index) {
      const confirmed = await this.ShowConfirm(
        'Confirmación',
        '¿Está seguro que desea eliminar el contrato?'
      );
      if (!confirmed) return;
      if (!contract.id) {
        this.user.sipaeeInfo.contracts.splice(index, 1);
      } else {
        await removeContract(contract.id, contract.isMediator).catch(() =>
          this.ShowToast('Error', 'Ha ocurrido un error', 'error')
        );
        await this.getContracts();
      }
    },
    async getContracts() {
      if (!this.user?.userId) return;
      const { data } = await getContracts(this.user.userId).catch(() =>
        this.ShowToast('Error', 'Ha ocurrido un error', 'error')
      );
      this.user.sipaeeInfo.contracts = data;
    },
    async updateContract(contract) {
      if (!this.user?.userId) return;
      await updateContract(contract.id, this.user.userId, contract);
      await this.getContracts();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/sass/config/_colors.scss';

.parent-profile ::v-deep {
  .label {
    font-size: 14px;
    font-weight: normal;
    color: map-get($colors, 'gray-6');
    margin-bottom: 0.25rem;
  }

  .content {
    font-weight: normal;
    font-size: 1rem;
    color: map-get($colors, 'black');
  }

  .result-pill {
    background-color: map-get($colors, 'gray-2');
    padding: 0.25rem 1.5rem;
    border-radius: 50rem;
    color: map-get($colors, 'white');
    margin: 0 auto 1.5rem;
    font-size: 0.9375rem;
    width: fit-content;
  }

  .not-found-result {
    font-weight: normal;
    color: map-get($colors, 'gray-3');
    text-align: center;
  }

  .result-row {
    display: block;
    margin: 0.25rem;
  }

  .search-input {
    width: 70%;
  }

  @media only screen and (max-width: 768px) {
    .search-input {
      width: 100%;
    }

    .border-right {
      border-right: unset !important;
    }

    .result-pill {
      margin-bottom: 1rem;
    }
  }
}
</style>